import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserResolve } from './core/resolver/user-resolver';
import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  { path: '', loadChildren: () => import('app/public/public.module').then(m => m.PublicModule) },
  { path: 'webplatform', resolve: { user: UserResolve }, loadChildren: () => import('app/core/core.module').then(m => m.CoreModule), canActivate: [AuthGuard] },

  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
